'use client';

import { useEffect, useState } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export const usePopup = <T extends object>(initialValue: T) => {
    const [isVisible, setIsVisible] = useState<T>(initialValue);

    const closePopup = (name: string) => {
        setIsVisible({ ...initialValue, [name]: false });
    };

    const closePopupWithTimeout = (name: string, timeout: number) => {
        setTimeout(() => {
            closePopup(name);
        }, timeout);
    };

    const openPopup = (name: string) => {
        setIsVisible({ ...initialValue, [name]: true });
    };

    useEffect(() => {
        Object.values(isVisible).includes(true)
            ? disableBodyScroll(document.body, { allowTouchMove: () => true })
            : enableBodyScroll(document.body);

        return () => {
            enableBodyScroll(document.body);
        };
    }, [isVisible]);

    return {
        isVisible: isVisible,
        openPopup: openPopup,
        closePopup: closePopup,
        closePopupWithTimeout: closePopupWithTimeout,
        setIsVisible: setIsVisible,
    };
};
